import { useEffect, useState } from "react";
import { server } from "../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelectAccess } from "../../store/stateFunctions";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Select,
} from "@mui/material";
import { Modal } from "react-bootstrap";
import Textarea from "@mui/joy/Textarea";

const initialValues = {
  fullname: "",
  problem_statement: "",
  idea: "",
};

const Innovation = () => {
  document.title = "Innovations";
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [show, setShow] = useState(false);
  const closeModal = () => setShow(false);

  const isLoggedIn = user && user;
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    org_name: "",
    email: "",
    statement: "",
    themes: "",
    category: "",
    id: "", // Added to store the id
  });

  // Added to store the id
  const [formId, setFormId] = useState("");

  const updateFormValues = (values) => {
    setFormValues({
      org_name: values.org_name,
      email: values.email,
      statement: values.statement,
      themes: values.themes,
      category: values.category,
      id: values.id, // Set the id in formValues
    });
    setFormId(values.id); // Store the id in formId
    handleOpen();
  };

  const handleOpen = () => {
    if (isLoggedIn) {
      setShow(true);
    } else {
      toast.info("Please log in to apply for the internship");
      navigate("/loginstudent");
    }
  };

  useEffect(() => {
    getData();
    getDashboard();
  }, []);

  const getData = () => {
    server
      .get("/ideas/getallinnovative_ideas", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          closeModal();
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getDashboard = () => {
    server
      .get("/ideas/dashboard", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setDashboard(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      fullname: Yup.string().required("Please Enter Your Full Name"),
      problem_statement: Yup.string()
        .min(2, "Enter Prablem Statement")
        .required("Please Enter Your password"),
      idea: Yup.string()
        .min(2, "Enter Your idea")
        .required("Please Enter Your idea"),
    }),

    onSubmit: (values) => {
      console.log(values);
      server
        .post(
          `/ideas/shareideas/${formId}`, // Use the stored id
          values,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: user.authToken,
            },
          }
        )
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Submitted successfully");
              resetForm();
              closeModal();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  return (
    <>
      <div className="container" id="hackathon" style={{ marginTop: "1rem" }}>
        <h2 className="mb-4 my-4">Problem Statements - Industry Challeges</h2>
        <p>
          Are you a student with a passion for problem-solving and a knack for
          innovation? Welcome to the Industry Challenges Platform – your gateway
          to making a real impact! Ready to be a catalyst for change? Dive into
          industry challenges, showcase your skills, and be part of a community
          that's shaping the future. Innovate, Empower, and Redefine the Future
          - Your Ideas Matter!
        </p>
        <br />
      </div>
      <section className="total-statement totstat " id="state">
        <div className="container card">
          <div className="row">
            <div className="statement-box">
              <div className="row" id="box">
                <div className="col pt-2" id="s1">
                  <h3>
                    <b>Total Statements</b>
                  </h3>
                  <p>As per available data</p>
                </div>

                <div className="col pt-2">
                  <div className="hard text-center">
                    <h3>{dashboard?.Hardware}</h3>
                    <p>Hardware</p>
                  </div>
                </div>
                <div className="col pt-2">
                  <div className="soft text-center">
                    <h3>{dashboard?.Software}</h3>
                    <p>Software</p>
                  </div>
                </div>
                <div className="col pt-2">
                  <div className="soft text-center">
                    <h3>{dashboard?.Other}</h3>
                    <p>Other</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <br />

      <div className="container" id="nitin">
        {/* <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="themeSelect">Select Theme:</label>
              <select className="form-control" id="themeSelect">
                <option value="">All Themes</option>
                <option value="theme1">SMART AUTOMATION</option>
                <option value="theme2">FITNESS & SPORTS</option>
                <option value="theme3">HERITAGE & CULTURE</option>
                <option value="theme3">MEDTECH/BIOTECH/ HEALTHTECH</option>
                <option value="theme3">
                  AGRICULTURE, FOODTECH & RURAL DEVELOPMENT
                </option>
                <option value="theme3">SMART VEHICLES</option>
                <option value="theme3">TRANSPORTATION & LOGISTICS</option>
                <option value="theme3">ROBOTICS AND DRONES</option>
                <option value="theme3">TOURISM</option>
                <option value="theme3">RENEWABLE/ SUSTAINABLE ENERGY</option>
                <option value="theme3">BLOCKCHAIN & CYBERSECURITY</option>
                <option value="theme3">SMART EDUCATION</option>
                <option value="theme3">DISASTER MANAGEMENT</option>
                <option value="theme3">TOYS AND GAMES</option>
                <option value="theme3">MISCELLANEOUS</option>
                <option value="theme3">SPACE TECHNOLOGY</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="categorySelect">Select Category:</label>
              <select className="form-control" id="categorySelect">
                <option value="">All Categories</option>
                <option value="category1">Hardware</option>
                <option value="category2">Software</option>
                <option value="category3">Other</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="orgSelect">Select Organization:</label>
              <select className="form-control" id="orgSelect">
                <option value="">All Organizations</option>
                <option value="org1">Organization 1</option>
                <option value="org2">Organization 2</option>
                <option value="org3">Organization 3</option>
              </select>
            </div>
          </div>
        </div> */}
      </div>
      <br />
      <div className="container" style={{ overflowX: "scroll" }}>
        <div className="row">
          <table className="table table-striped border">
            <thead className="text-center">
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Organization Name</th>
                <th scope="col">Email</th>
                <th scope="col">Problem Statement</th>
                <th scope="col">Industry Type</th>
                <th scope="col">Category</th>
                <th scope="col">Submitted Ideas Count</th>
                <th>Share</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {data.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.org_name}</td>
                    <td>{item.email}</td>
                    <td>{item.statement}</td>
                    <td>{item.industry_type}</td>
                    <td>{item.category}</td>
                    <td>{item.ideas_received}</td>
                    <td>
                      <a
                        onClick={() => updateFormValues(item)}
                        className="fw-bold"
                        style={{ cursor: "pointer" }}
                      >
                        Share
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header className="bg-light" closeButton>
          <Modal.Title>
            <h5>Share Your Idea</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="form-outline mb-2">
              <TextField
                name="org_name"
                margin="dense"
                type="text"
                placeholder="Organization Name"
                variant="outlined"
                label=" Organization Name"
                value={formValues.org_name}
                disabled
                onChange={(e) =>
                  setFormValues({ ...formValues, org_name: e.target.value })
                }
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="email"
                margin="dense"
                type="text"
                placeholder="Email"
                variant="outlined"
                label="Email"
                value={formValues.email}
                disabled
                onChange={(e) =>
                  setFormValues({ ...formValues, email: e.target.value })
                }
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="statement"
                margin="dense"
                type="text"
                placeholder="Problem Statement"
                variant="outlined"
                label="Problem Statement"
                value={formValues.statement}
                disabled
                onChange={(e) =>
                  setFormValues({ ...formValues, statement: e.target.value })
                }
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="themes"
                margin="dense"
                type="text"
                placeholder="Industry Type"
                variant="outlined"
                label="Industry Type"
                value={formValues.themes}
                disabled
                onChange={(e) =>
                  setFormValues({ ...formValues, themes: e.target.value })
                }
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>{" "}
            <div className="mb-2">
              <FormControl
                fullWidth
                required
                className="mt-2"
                id="demo-simple-select-label"
                disabled
              >
                <InputLabel>Choose Category</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="category"
                  value={formValues.category}
                  onChange={(e) =>
                    setFormValues({ ...formValues, category: e.target.value })
                  }
                >
                  <MenuItem value="software">Software</MenuItem>
                  <MenuItem value="hardware">Hardware</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="fullname"
                margin="dense"
                type="text"
                placeholder="Full Name"
                variant="outlined"
                label="Full Name"
                value={values.fullname}
                onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <TextField
                name="problem_statement"
                margin="dense"
                type="text"
                placeholder="Problem Statement"
                variant="outlined"
                label="Problem Statement"
                value={values.problem_statement}
                onChange={handleChange}
                fullWidth
                required
              ></TextField>
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="form-outline mb-2">
              <Textarea
                minRows={4}
                name="idea"
                className="my-3"
                value={values.idea}
                onChange={handleChange}
                placeholder="Define the solution (in 200-300 words)"
              />
              {/* {errors.email ? (
                          <p className="text-danger">{errors.email}</p>
                      ) : null} */}
            </div>
            <div className="pt-1 mb-2">
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Innovation;
